/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { Form } from 'react-final-form';
import PropTypes from 'prop-types';
import { useValidationSchema } from '../../hooks';

export const FxReactFinalFormWrapper = ({
                                          initialValues,
                                          validationSchema,
                                          validationContext,
                                          onSubmit,
                                          canPreventEnterSubmit,
                                          children,
                                        }) => {
  const validate = useValidationSchema(validationSchema, validationContext);

  return (
    <Form
      validate={validate}
      onSubmit={onSubmit}
      initialValues={initialValues}
      debug={(state, fieldStates) => console.log(state, fieldStates)}
      render={({ handleSubmit }) => (
        <form
          onSubmit={handleSubmit}
          onKeyDown={(e) => {
            if (canPreventEnterSubmit && e.key === 'Enter') {
              e.preventDefault();
            }
          }}
        >
          {children}
        </form>
      )}
    />
  );
};

FxReactFinalFormWrapper.propTypes = {
  initialValues: PropTypes.shape({}),
  validationSchema: PropTypes.shape({}),
  validationContext: PropTypes.shape({}),
  onSubmit: PropTypes.func,
  children: PropTypes.node.isRequired,
  canPreventEnterSubmit: PropTypes.bool,
};

FxReactFinalFormWrapper.defaultProps = {
  initialValues: {},
  validationSchema: null,
  validationContext: {},
  onSubmit: () => {
  },
  canPreventEnterSubmit: false,
};
